<script>
import {useCatalogStore} from "@/stores/Training/Catalog.js"
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {onMounted, watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import axios from "axios";

export default {
    props: {
        rootPath: String,
    },
    setup(props) {
        const {total, loading, filter} = useSharedData();

        const {priceFormat, transformFilterValues} = useSharedMethod();

        const {$i18n, $router} = useTools();

        const catalogStore = useCatalogStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                sortable: true,
                value: "name",
                width: "0%"
            },
            {
                text: $i18n.t("common.duration"),
                align: "left",
                sortable: true,
                value: "duration",
                width: "0%"
            },
            {
                text: $i18n.t("training.catalog_price"),
                align: "left",
                sortable: true,
                value: "price",
                width: "0%"
            },
            {
                text: $i18n.t("training.catalog_objective"),
                align: "left",
                sortable: true,
                value: "objective",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_TRAINING_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${props.rootPath}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_TRAINING_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${props.rootPath}.delete`, params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/catalogs', {params: transformFilterValues(filter.value)}).then((response) => {
                catalogStore.setCatalogs(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findAll());

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        function view(item) {
            $router.push({name: `${props.rootPath}.view`, params: {id: item.id}});
        }

        return {
            catalogStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            priceFormat,
            view,
            findAll,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.training_catalog')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_TRAINING_PARAM']"
                    @press="$router.push({ name: `${rootPath}.add` })"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="3">
                            <w-text-field
                                v-model="filter.name"
                                :label="$t('common.name')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="catalogStore.catalogs"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >

                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                        <w-btn-icon-help :text="item.program"/>
                    </template>
                    <template v-slot:[`item.duration`]="{ item }">
                        <w-inline-text :text="`${item.duration} ${$t('training.catalog_days')}`"/>
                    </template>
                    <template v-slot:[`item.price`]="{ item }">
                        <w-inline-text :text="priceFormat(item.price)"/>
                    </template>
                    <template v-slot:[`item.objective`]="{ item }">
                        <w-inline-text :text="item.objective"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
